import React from 'react';
import cardUtils from '../../utils/cardUtils';
import AddToCartButton from '../shoppingCart/AddToCartButton';
import AddToWishlistButton from '../wishlist/AddToWishlistButton';
import AddToCollectionButton from '../collection/AddToCollectionButton';
import Button from '../common/Button';

const CardName = props => {
  const { card } = props;
  const sortedPrices =
    card.cardPrices && card.cardPrices.length
      ? cardUtils.sortPrices(card.cardPrices)
      : null;

  return (
    <div className="w-full flex flex-row items-center bg-mediumColor p-4 rounded-md gap-x-2">
      <div className="w-full md:w-1/3">
        <h4 className="text-lg text-white">
          {card.name}{' '}
          {sortedPrices
            ? `(${cardUtils.calculatePrice(sortedPrices[0])})`
            : '(Sin stock)'}
        </h4>
      </div>
      <div className="w-full md:w-1/6">
        <AddToWishlistButton card={card} />
      </div>
      <div className="w-full md:w-1/6">
        {/* The Deck Builder's card list swaps in a deck-quantity stepper here;
            everywhere else this is the collection stepper. */}
        {props.quantityControl || <AddToCollectionButton card={card} />}
      </div>
      {sortedPrices && (
        <>
          <div className="w-full md:w-1/6">
            <AddToCartButton card={card} price={sortedPrices[0]} />
          </div>
          <div className="w-full md:w-1/6">
            <a
              href={sortedPrices[0].storeUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full">
              <Button className="w-full" iconClass="fas fa-shopping-basket">
                Ver en tienda
              </Button>
            </a>
          </div>
        </>
      )}
      <div className="w-full md:w-1/6">
        <a
          href={card.cardUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full">
          <Button className="w-full" iconClass="fas fa-database">
            Ver en Scryfall
          </Button>
        </a>
      </div>
    </div>
  );
};

export default CardName;
